import { render, staticRenderFns } from "./ndr1.vue?vue&type=template&id=9996805a&scoped=true"
import script from "./ndr1.vue?vue&type=script&lang=js"
export * from "./ndr1.vue?vue&type=script&lang=js"
import style0 from "./ndr1.vue?vue&type=style&index=0&id=9996805a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9996805a",
  null
  
)

export default component.exports